import User from '@/views/User/models/user'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
    inheritAttrs: false,
})
export default class UserAvatar extends Vue {
    @Prop() item!: User | null
}
